import { _ } from '@icc/shared/helpers/b2b';

export interface SalesDocumentClient {
    id?: number;
    isCompany: boolean;
    firstName: string | null;
    lastName: string | null;
    reference: string;
    email: string | null;
    phoneNumber: string | null;
    deliveryEmail?: string | null;
    deliveryPhone?: string | null;
    invoiceEmail?: string | null;
    invoicePhone?: string | null;
    companyName: string | null;
    companyVatNr: string | null;
    companyVatNrEu: string | null;
    deliveryId: number | null;
    delivery: ClientAddress | null;
    invoiceFromDelivery: boolean;
    invoice: ClientAddress | null;
    invoiceId?: number | null;
    otherContact: boolean;
    billingDeliveryId: number | null;
    billingDelivery: ClientAddress | null;
}

export interface ClientAddress {
    id?: number;
    countryId: string;
    regionId: number | null;
    subregionId: number | null;
    addressLine1: null | string;
    addressLine2: null | string;
    postalCode: null | string;
    city: null | string;
}

export const SalesDocumentClientReadablePropsNames: Record<keyof SalesDocumentClient, string> = {
    id: _('INTERFACE|ID'),
    isCompany: _('SALES_DOCUMENT|Typ klienta'),
    firstName: _('PERSON|Imię'),
    lastName: _('PERSON|Nazwisko'),
    reference: _('SALES_DOCUMENT|Numer klienta'),
    email: _('CONTACT|Email'),
    phoneNumber: _('CONTACT|Telefon'),
    deliveryEmail: _('CONTACT|Email dostawy'),
    deliveryPhone: _('CONTACT|Telefon dostawy'),
    invoiceEmail: _('CONTACT|Email faktury'),
    invoicePhone: _('CONTACT|Telefon faktury'),
    companyName: _('COMPANY|Nazwa firmy'),
    companyVatNr: _('COMPANY|NIP'),
    companyVatNrEu: _('COMPANY|EU VAT'),
    deliveryId: _('CONTACT|ID adresu dostawy'),
    delivery: _('CONTACT|Adres dostawy'),
    invoiceFromDelivery: _('CONTACT|Faktura z adresu dostawy'),
    invoice: _('CONTACT|Adres faktury'),
    invoiceId: _('CONTACT|ID adresu faktury'),
    otherContact: _('CONTACT|Inny adres kontaktowy'),
    billingDeliveryId: _('CONTACT|ID adresu do wysyłki dokumentów'),
    billingDelivery: _('CONTACT|Adres do wysyłki dokumentów'),
};

export const ClientAddressReadablePropsNames: Record<keyof ClientAddress, string> = {
    id: _('INTERFACE|ID'),
    countryId: _('CONTACT|Kraj'),
    regionId: _('CONTACT|Region'),
    subregionId: _('CONTACT|Podregion'),
    addressLine1: _('CONTACT|Adres linia 1'),
    addressLine2: _('CONTACT|Adres linia 2'),
    postalCode: _('CONTACT|Kod pocztowy'),
    city: _('CONTACT|Miasto'),
};